import { AMOUNT_WITHOUT_DECIMAL_PATTERN } from '@/constants/patterns';

const WHITESPACE_PATTERN = /\s/;
const LETTERS_PATTERN = /[a-zA-Z]/;
const DIGITS_PATTERN = /\d/;
const ALLOWED_CHARS_PATTERN = /[^0-9.]/;
const DOT_PATTERN = /\./g;

const CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS = {
  spaceNotAllowed:
    'questionDrawer.aboutFundingSource.fundingAmount.spaceNotAllowed',
  lettersNotAllowed:
    'questionDrawer.aboutFundingSource.fundingAmount.lettersNotAllowed',
  negativeNotAllowed:
    'questionDrawer.aboutFundingSource.fundingAmount.specialCharsNotAllowed',
  commasNotAllowed:
    'questionDrawer.monthlyDeposit.monthlyDepositAmount.cayman.commasNotAllowed',
  genericSpecialCharsNotAllowed:
    'questionDrawer.monthlyDeposit.monthlyDeposit.pattern',
  noDecimalAllowed:
    'questionDrawer.monthlyDeposit.monthlyDepositAmount.cayman.pattern',
} as const;

export const isValidCaymanMonthlyDepositAmount = (
  value: string,
): string | true => {
  if (!value) return true;

  if (WHITESPACE_PATTERN.test(value)) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.spaceNotAllowed;
  }

  const hasLetters = LETTERS_PATTERN.test(value);
  const hasDigits = DIGITS_PATTERN.test(value);

  if (hasLetters && hasDigits) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.lettersNotAllowed;
  }

  if (hasLetters) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.genericSpecialCharsNotAllowed;
  }

  if (value.includes(',')) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.commasNotAllowed;
  }

  if (ALLOWED_CHARS_PATTERN.test(value)) {
    return value.includes('-')
      ? CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.negativeNotAllowed
      : CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.genericSpecialCharsNotAllowed;
  }

  if ((value.match(DOT_PATTERN) ?? []).length > 1) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.noDecimalAllowed;
  }

  if (value.includes('.')) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.noDecimalAllowed;
  }

  if (!AMOUNT_WITHOUT_DECIMAL_PATTERN.test(value)) {
    return CAYMAN_MONTHLY_DEPOSIT_TRANSLATION_KEYS.noDecimalAllowed;
  }

  return true;
};

export const roundCaymanMonthlyDepositAmountOnBlur = (
  raw: string,
): string | null => {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (trimmed.includes(',')) return null;

  if (trimmed.includes('.')) {
    const parsed = parseFloat(trimmed);
    if (Number.isNaN(parsed)) return null;
    return String(Math.round(parsed));
  }

  if (AMOUNT_WITHOUT_DECIMAL_PATTERN.test(trimmed)) {
    return trimmed;
  }

  return null;
};
